import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

export const cryptoRelationshipField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Crypto relationship',
    context: 'The relationship between the company and the cryptocurrency.',
  }),
};
